import { Component, OnInit } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';
import { GasTravel } from 'src/app/models/gas-travel';
import { AuthService } from 'src/app/services/auth.service';
import { UnityService } from 'src/app/services/unity.service';
import { from } from 'rxjs';
import { groupBy, mergeMap, toArray } from 'rxjs/operators';

@Component({
  selector: 'app-pending-gas',
  templateUrl: './pending-gas.component.html',
  styleUrls: ['./pending-gas.component.css']
})
export class PendingGasComponent implements OnInit {
  data:GasTravel[] = [];
  groupedData:any[] = [];
  loading:boolean = false;
  canUpload:boolean = false;

  constructor( private reportSer:ReportService, private auth:AuthService, private unityServ:UnityService ) { }

  ngOnInit() {
    this.search();
    this.canUpload = this.auth.can('emmit-gas');
  }

  search () {
    this.loading = true;
    let groupedDataTmp = [];

    this.reportSer.getPendingGasReport().then(resp => {
      this.data = resp;
      from(this.data)
        .pipe(
          groupBy(x => x.gas_date.substr(0,10)),
          mergeMap(x => x.pipe(toArray())),
        ).subscribe(resp => {
          if (groupedDataTmp.length) {
            let index = this.getIndexToInsert(groupedDataTmp, new Date(resp[0].gas_date));
            groupedDataTmp.splice(index, 0, resp);
          } else {
            groupedDataTmp.push(resp);
          }
        }, null, () => {
          this.groupedData = groupedDataTmp;
        });
      this.loading = false;
    });
  }

  upload(date:string) {
    this.loading = true;
    this.unityServ.uploadToSap(date)
      .then(resp => this.search());
  }

  getIndexToInsert(array, newDate:Date) {
    let i = 0;

    for (i = 0; i < array.length; i++) {
      let actualDate = new Date(array[i][0].gas_date);

      if (actualDate > newDate) {
        return i;
      }
    }

    return i;
  }
}
